export default __webpack_public_path__ + "static/media/girl.eb133c40.png";